import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3h10v18h-10l0 -18","key":"svg-0"}]]

const IconBrandNationalGeographic = createReactComponent('outline', 'brand-national-geographic', 'BrandNationalGeographic', __iconNode);

export default IconBrandNationalGeographic;